<template>
  <div>
    <!-- 学生考勤---我的考勤 -->
    <div class="stat-select">
      <SelectTimeDate ref="SelectTimeDate" @timeDate="GetMyAttSummary"></SelectTimeDate>
    </div>
    <Attendance v-bind:StudentNum="StudentNum"></Attendance>
    <Proportion v-bind:Summary="Summary"></Proportion>
    <div class="end-time">数据截止到：{{EndTime}}</div>
  </div>
</template>
<script>
import SelectTimeDate from "@/pages/attendance/components/SelectTimeDate";
import Attendance from "@/pages/attendance/components/Attendance";
import Proportion from "@/pages/attendance/components/Proportion";

export default {
  name: "MyAttendance",
  components: {
    SelectTimeDate,
    Attendance,
    Proportion
  },
  data() {
    return {
      StudentNum: "",
      Summary: [],
      EndTime: "",
      ChildrenID: ""
    };
  },
  created() {
    this.ChildrenID = this.$store.state.parentInfo.childData.ChildrenID;
  },
  watch: {},
  mounted() {},

  methods: {
    async GetMyAttSummary(item) {
      let params = {
        StartTime: item[0],
        EndTime: item[1],
        StudentID: this.ChildrenID
      };
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/StudentLeave/GetChildrenAttSummary",
        params
      );
      if (res.success) {
        this.StudentNum = res.data;
        this.Summary = res.data.Summary;
        this.EndTime = res.data.EndTime;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.stat-select {
  background: #fff;
  overflow: hidden;
  margin-bottom: 20px;
}
.end-time {
  position: fixed;
  bottom: 0;
  text-align: center;
  width: 100%;
  color: #888;
  padding: 7px 0;
  background-color: #f9f9f9 !important;
}
</style>
